import React, {
  useCallback, useMemo,
  useState,
} from 'react';
import { Select, MenuItem, Box } from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';
import clsx from 'clsx';

import { selectListScenes } from '../../../store/modules/scenes/selectors';
import {
  setStartDelayTime,
  setDropdownSelectMode,
} from '../../../store/modules/studio/actions';
import { StudioControlStyles } from '../styles';
import {
  selectCameraRecording, selectCountdownCamera,
  selectIsCountdown,
  selectIsPlayPrompter,
  selectStartDelayTime,
  selectStudioMode
} from '../../../store/modules/studio/selectors';
import {startDelayOptions as options, StudioMode} from '../../../configs/studio';
import StudioToolTip from './StudioToolTip';
import StyledInput from './StyledInput';

type Props = {
  isHidden?: boolean;
};

const StartDelayAction = ({ isHidden, }: Props) => {
  const classes = StudioControlStyles();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);

  const scriptList = useSelector(selectListScenes);
  const currentStartDelayTime = useSelector(selectStartDelayTime);
  const isPlay = useSelector(selectIsPlayPrompter);
  const isCountdown = useSelector(selectIsCountdown);
  const isCountdownCamera = useSelector(selectCountdownCamera);
  const studioMode = useSelector(selectStudioMode);
  const cameraRecording = useSelector(selectCameraRecording);

  const onChange = useCallback((event: React.ChangeEvent<{value: unknown}>) => {
      const eventValue = event.target.value as number;
      dispatch(setStartDelayTime(eventValue));
  }, [dispatch]);

  const disabled = useMemo(()=>{
    return Boolean(isPlay || isCountdown || cameraRecording || isCountdownCamera);
  },[isPlay, isCountdown, cameraRecording, isCountdownCamera]);

  const openHandler = useCallback(() => {
    setOpen(true);
    dispatch(setDropdownSelectMode(true));
  }, [dispatch, setOpen]);

  const closeHandler = useCallback(() => {
    setOpen(false);
    dispatch(setDropdownSelectMode(false));
  }, [dispatch, setOpen]);


  if (scriptList.data?.items.length === 0) {
    return null;
  }

  return (
    <StudioToolTip title={`Delay the start of scrolling after Play prompter / the start of recording after Start recording is pressed  `}>
      <Box hidden={isHidden} mt={2} className={classes.selectionWrapper}>
        <p className={classes.label}>Delay Start</p>
        <Select
          open={open}
          variant="outlined"
          className={clsx(classes.selection, classes.delayStartSelect, {
            [classes.delayStartSelectCamera]: (studioMode === StudioMode.CAMERA),
            [classes.delayStartSelect]: (studioMode === StudioMode.TELEPROMPTER),
          })}
          input={<StyledInput />}
          value={currentStartDelayTime}
          onChange={onChange}
          MenuProps={{ style: { zIndex: 2147483102 } }}
          disabled={disabled}
          data-intercom-target="Dropdown: Delay Start"
          onOpen={openHandler}
          onClose={closeHandler}
        >
          {options.map((item) => (
            <MenuItem key={item.value} value={item.value}>
              {item.label}
            </MenuItem>
          ))}
        </Select>
      </Box>
    </StudioToolTip>
  );
};

export default StartDelayAction;
